module.exports = __webpack_public_path__ + "static/media/competency-menu-icon.0b0763cf.svg";